<template>
	<div class="mt-4">
		<vs-sidebar
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarEditActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("VisitPoints.UpdatePointofVisit") }}</h4>
				<feather-icon
					icon="XIcon"
					class="cursor-pointer"
					@click.stop="isSidebarEditActive = false"
				></feather-icon>
			</div>
			<job-edit
				v-if="isSidebarEditActive"
				:data="jobObject"
				@toggleAllEmit="toggleAllEmit()"
				@closeSidebarEmit="closeSidebar()"
			/>
		</vs-sidebar>
		<vs-collapse v-if="jobsSelected.length > 0" id="JobsItem" type="border" :key="renderComponent">
			<vs-collapse-item v-for="(job, index) in jobsSelected" :key="index" :open="isExpanded">
				<div slot="header">
					<div class="flex items-center justify-between">
						<span>{{ job.name }}</span>
						<div class="flex items-center mr-6" style="position: absolute; right: 10px">
							<feather-icon
								:class="{'text-danger font-bold': showErrorOptimization(index)}"
								svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
								:icon="showErrorOptimization(index) ? 'AlertCircleIcon' : 'EditIcon'"
								:title="showErrorOptimization(index) ? $t('ManualData.FixErrorsHere') : $t('Edit')"
								@click.prevent="editJob(job, index)"
							/>
							<feather-icon
								icon="Trash2Icon"
								svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
								:title="$t('Crud.Delete')"
								@click.prevent="removeAssignedJob(job)"
							/>
						</div>
					</div>
				</div>
				<vs-list>
					<vs-list-item
						v-for="(pickup, indexPickup) in job.pickups"
						:key="indexPickup"
						:title="pickup"
						:subtitle="$t('PICKUP')"
					>
						<template slot="avatar">
							<vs-avatar color="#420D91" icon-pack="feather" icon="icon-truck" />
						</template>
						<div class="vx-row">
							<div class="vx-col w-full">
								<div class="flex flex-wrap items-center justify-end">
									<feather-icon
										icon="MapIcon"
										svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
										:title="$t('SeeDetailedInformation')"
										@click="showInfo('pickup', pickup)"
									/>
								</div>
							</div>
						</div>
					</vs-list-item>
					<vs-list-item
						v-for="(delivery, indexDelivery) in job.deliveries"
						:key="indexDelivery"
						:title="delivery"
						:subtitle="$t('DELIVERY')"
					>
						<template slot="avatar">
							<vs-avatar color="#FF9F43" icon-pack="feather" icon="icon-package" />
						</template>
						<div class="vx-row">
							<div class="vx-col w-full">
								<div class="flex flex-wrap items-center justify-end">
									<feather-icon
										icon="MapIcon"
										svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
										:title="$t('SeeDetailedInformation')"
										@click="showInfo('delivery', delivery)"
									/>
								</div>
							</div>
						</div>
					</vs-list-item>
				</vs-list>
			</vs-collapse-item>
		</vs-collapse>
		<p class="mt-10 text-center font-semibold text-secondary" v-else>
			{{ textSearch(searchQueryPickup ? "search" : "") }}
		</p>
		<vs-popup id="job-planning" class="vs-con-loading__container" :title="null" :active.sync="showPopup">
			<job-popup-map
				v-if="showPopup"
				:name="mapConfig.name"
				:data="visitPointJobDetail"
				:zoom="mapConfig.zoom"
				:theme="mapConfig.theme"
				:calledFrom="mapConfig.calledFrom"
			/>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import JobEdit from "@/components/optimization/jobs/edit/JobEdit.vue";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import DetailVisitPointShipments from "@/components/optimization/visit-point/DetailVisitPointShipments.vue";
import JobPopupMap from "@/components/optimization/jobs/JobPopupMap.vue";

export default {
	name: "JobPlanningItem",
	components: {
		vSelect,
		flatPickr,
		JobEdit,
		JobPopupMap,
		DetailVisitPointShipments,
	},
	props: {
		jobsSelected: {
			type: Array,
			default: () => [],
		},
		searchQueryPickup: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			renderComponent: 0,
			visitPointJobDetail: null,
			showPopup: false,
			isSidebarEditActive: false,
			isExpanded: false,
			jobObject: {},
			mapConfig: {
				name: "job-map",
				latitude: 4.686699,
				longitude: -74.0837187,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
		};
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	computed: {
		textSearch() {
			return (type) => {
				if (type === "search") return this.$t("NoResultsWereFoundForYourSearch");
				return this.$t("ThereIsNoDataToDisplayPleaseTryToAddNewRecords");
			};
		},
		showErrorOptimization() {
			return (indexJob) => {
				const errorFilter = this.$store.state.moduleOptimization.errorList.filter((data) => {
					return data.absolute_path[0] == "jobs" && data.absolute_path[1] === indexJob;
				});
				return errorFilter.length > 0;
			};
		},
		pickupList() {
			const pickups = this.$store.state.moduleOptimization.standardInputList["pickups"];
			return pickups === undefined || pickups === "" || pickups === null ? [] : pickups;
		},
		deliveryList() {
			const deliveries = this.$store.state.moduleOptimization.standardInputList["deliveries"];
			return deliveries === undefined || deliveries === "" || deliveries === null ? [] : deliveries;
		},
	},
	methods: {
		closeSidebar() {
			this.isSidebarEditActive = false;
		},
		toggleAll() {
			this.isExpanded = !this.isExpanded;
			this.$emit("getExpanded", this.isExpanded);
			this.renderComponent++;
		},
		toggleAllEmit() {
			this.isExpanded = false;
			this.renderComponent++;
		},
		editJob(val, index) {
			this.jobObject = val;
			this.jobObject.indexJob = index;
			this.isSidebarEditActive = true;
		},
		removeAssignedJob(job) {
			this.$store.commit("moduleOptimization/DELETE_JOB_SELECTED_STANDARD_INPUT", job);
		},
		showInfo(type, item) {
			if (type === "pickup") {
				this.visitPointJobDetail = this.pickupList.filter((data) => data.identification === item)[0];
			} else {
				this.visitPointJobDetail = this.deliveryList.filter((data) => data.identification === item)[0];
			}
			const {latitude, longitude} = this.visitPointJobDetail;
			this.mapConfig.latitude = latitude;
			this.mapConfig.longitude = longitude;
			this.showPopup = true;
		},
	},
};
</script>

<style lang="scss" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
<style lang="scss">
#JobsItem {
	.vs-collapse-item--header {
		color: rgba(var(--vs-dark), 1);
		font-weight: bold;
		font-size: 17px;
	}
}
#job-planning {
	/* Hide the default close button of the InfoWindow */
	.gm-ui-hover-effect {
		display: none !important;
	}
	.custom-info-window {
		padding: 10px;
		background-color: white;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
}
</style>
